import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useReducer, useRef, useState, } from 'react';
import useSupercluster from 'use-supercluster';
const BKJInteractiveMapContext = createContext(null);
const getInitialState = (zoom) => ({
    bounds: null,
    zoom,
});
const reducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case 'MapChangeEvent':
            return {
                ...state,
                bounds: payload.bounds,
                zoom: payload.zoom,
            };
        default:
            return state;
    }
};
export const BKJInteractiveMapProvider = ({ setMapInstance, children, apiKey, points, pinComponent, name, clusterComponent, defaultCenter, defaultZoom = 17, onChange: onBoundsChange, clusterRadius = 75, maxZoom = 21, isLoading: __isLoading__ = false, minZoom = 10, clusterMapper, clusterReduce, }) => {
    const gMapInstanceRef = useRef(null);
    const gMapsApiRef = useRef(null);
    const [{ zoom, bounds }, dispatch] = useReducer(reducer, getInitialState(defaultZoom));
    const { clusters, supercluster } = useSupercluster({
        points,
        bounds,
        zoom,
        options: {
            radius: clusterRadius,
            maxZoom,
            minZoom,
            map: clusterMapper,
            reduce: clusterReduce,
        },
    });
    const [isLoading, setLoading] = useState(true);
    const handleMapChange = useCallback((event) => {
        const { zoom, bounds: { nw: { lng: northWestLongitude, lat: northWestLatitude }, ne: { lng: northEastLongitude, lat: northEastLatitude }, sw: { lng: southWestLongitude, lat: southWestLatitude }, se: { lng: southEastLongitude, lat: southEastLatitude }, }, } = event;
        const __normalizedEvent__ = {
            target: {
                name,
                value: {
                    northWest: { latitude: northWestLatitude, longitude: northWestLongitude },
                    northEast: { latitude: northEastLatitude, longitude: northEastLongitude },
                    southWest: { latitude: southWestLatitude, longitude: southWestLongitude },
                    southEast: { latitude: southEastLatitude, longitude: southEastLongitude },
                },
            },
        };
        if (onBoundsChange)
            onBoundsChange(__normalizedEvent__);
        dispatch({
            type: 'MapChangeEvent',
            payload: {
                zoom: zoom,
                bounds: [northWestLongitude, southEastLatitude, southEastLongitude, northWestLatitude],
            },
        });
    }, [name, onBoundsChange]);
    const handleGoogleApiLoaded = useCallback(({ map, maps }) => {
        if (!gMapInstanceRef.current) {
            gMapInstanceRef.current = map;
            if (setMapInstance)
                setMapInstance(map);
        }
        else if (!gMapsApiRef.current) {
            gMapsApiRef.current = maps;
        }
        setLoading(false);
    }, [setMapInstance]);
    const onDrag = useCallback(() => {
        setLoading(true);
    }, []);
    const onDragEnd = useCallback(() => {
        setLoading(false);
    }, []);
    return (_jsx(BKJInteractiveMapContext.Provider, { value: {
            maxZoom,
            minZoom,
            gMapInstance: gMapInstanceRef.current,
            gMapsApi: gMapsApiRef.current,
            bounds,
            clusters,
            supercluster: supercluster,
            zoom,
            onMapChange: handleMapChange,
            onGoogleApiLoaded: handleGoogleApiLoaded,
            onDrag,
            apiKey,
            pinComponent,
            isLoading: isLoading || __isLoading__,
            clusterComponent,
            onDragEnd,
            defaultCenter,
            defaultZoom,
        }, children: children }));
};
export const useBKJInteractiveMapContext = () => useContext(BKJInteractiveMapContext);
//# sourceMappingURL=BKJInteractiveMap.context.js.map